/* Global Buy tools: product compare + package builder */
(function () {
  'use strict';
  var KEY = 'gbCompare', MAX = 4;
  var money = function (cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var store = {
    get: function () { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } },
    set: function (a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  };

  /* ---------- Tag labels (shared with filters) ---------- */
  var LABELS = {
    brand_lg: 'LG', brand_ge: 'GE', brand_cafe: 'Café', brand_fisher_paykel: 'Fisher & Paykel', brand_zline: 'ZLINE',
    subcategory_otr_microwave: 'Over-the-Range Microwave', subcategory_ada_dishwasher: 'ADA Compliant Dishwasher',
    subcategory_all_in_one: 'All-in-One Washer/Dryer', feature_smart_wifi: 'Wi-Fi Connected', feature_energy_star: 'ENERGY STAR',
    feature_air_fry: 'Air Fry', feature_smart_tv: 'Smart TV', resolution_4k: '4K Ultra HD', resolution_8k: '8K', resolution_hd: 'HD',
    resolution_fhd: 'Full HD 1080p', resolution_qhd: 'QHD', technology_qled: 'QLED', technology_oled: 'OLED', technology_led: 'LED',
    technology_mini_led: 'Mini-LED', technology_micro_led: 'Micro LED', technology_micro_rgb: 'Micro RGB', fuel_dual: 'Dual Fuel'
  };
  var TAG_ROWS = [
    ['subcategory_', 'Type'], ['screen_size_', 'Screen Size'], ['resolution_', 'Resolution'], ['technology_', 'Display Type'],
    ['fuel_', 'Fuel Type'], ['color_', 'Color / Finish'], ['feature_', 'Features']
  ];
  function tagLabel(t, prefix) {
    if (LABELS[t]) return LABELS[t];
    var rest = t.slice(prefix.length);
    if (prefix === 'screen_size_') return rest + '"';
    return rest.split('_').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(' ');
  }

  /* ---------- Compare: toggles + tray ---------- */
  function findItem(list, h) { for (var i = 0; i < list.length; i++) if (list[i].h === h) return i; return -1; }

  function syncToggles() {
    var list = store.get();
    document.querySelectorAll('[data-gb-compare]').forEach(function (cb) {
      cb.checked = findItem(list, cb.dataset.handle) > -1;
    });
  }

  function renderTray(msg) {
    var tray = document.getElementById('gbCmpTray');
    if (!tray) return;
    var list = store.get();
    var slots = '';
    for (var i = 0; i < MAX; i++) {
      var it = list[i];
      slots += it
        ? '<div class="gb-cmptray__item"><img src="' + esc(it.i) + '" alt="" width="56" height="56"><span class="gb-cmptray__name">' + esc(it.t) + '</span><button type="button" class="gb-cmptray__x" data-gb-cmp-remove="' + esc(it.h) + '" aria-label="Remove ' + esc(it.t) + ' from compare">&times;</button></div>'
        : '<div class="gb-cmptray__item gb-cmptray__item--empty" aria-hidden="true"><span>+</span></div>';
    }
    var href = '/pages/compare?p=' + list.map(function (x) { return encodeURIComponent(x.h); }).join(',');
    tray.innerHTML =
      '<div class="gb-cmptray__in">' +
        '<div class="gb-cmptray__head"><strong>Compare ' + (list[0] && list[0].c ? esc(list[0].c) + 's' : 'products') + '</strong><span>' + list.length + ' of ' + MAX + ' selected</span></div>' +
        '<div class="gb-cmptray__items">' + slots + '</div>' +
        '<div class="gb-cmptray__acts">' +
          (list.length >= 2 ? '<a class="gb-btn gb-btn--buy" href="' + href + '">Compare Now</a>' : '<span class="gb-cmptray__hint">Pick one more to compare</span>') +
          '<button type="button" class="gb-cmptray__clear" data-gb-cmp-clear>Clear all</button>' +
        '</div>' +
        (msg ? '<p class="gb-cmptray__msg" role="status">' + esc(msg) + '</p>' : '') +
      '</div>';
    tray.hidden = list.length === 0;
    document.body.classList.toggle('gb-has-cmp', list.length > 0);
  }

  function toggle(cb) {
    var list = store.get(), h = cb.dataset.handle, idx = findItem(list, h), msg = '';
    if (cb.checked && idx < 0) {
      if (list.length && list[0].c && cb.dataset.type && list[0].c !== cb.dataset.type) {
        cb.checked = false;
        msg = 'You are comparing ' + list[0].c + 's. Clear the list to compare ' + cb.dataset.type + 's instead.';
      } else if (list.length >= MAX) {
        cb.checked = false;
        msg = 'You can compare up to ' + MAX + ' products. Remove one to add another.';
      } else {
        list.push({ h: h, t: cb.dataset.title, i: cb.dataset.img, c: cb.dataset.type || '' });
      }
    } else if (!cb.checked && idx > -1) {
      list.splice(idx, 1);
    }
    store.set(list);
    syncToggles();
    renderTray(msg);
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-gb-compare]')) toggle(e.target);
  });
  document.addEventListener('click', function (e) {
    var r = e.target.closest && e.target.closest('[data-gb-cmp-remove]');
    if (r) {
      var list = store.get(), i = findItem(list, r.getAttribute('data-gb-cmp-remove'));
      if (i > -1) list.splice(i, 1);
      store.set(list); syncToggles(); renderTray();
      return;
    }
    if (e.target.closest && e.target.closest('[data-gb-cmp-clear]')) {
      store.set([]); syncToggles(); renderTray();
    }
  });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncToggles(); renderTray(); } });

  /* ---------- Compare page ---------- */
  function parseDesc(html) {
    var out = { hl: [], glance: [], specs: [] };
    if (!html) return out;
    var d = new DOMParser().parseFromString(html, 'text/html');
    d.querySelectorAll('.gb-pd__hl li').forEach(function (li) { out.hl.push(li.textContent.trim()); });
    d.querySelectorAll('.gb-pd__glance tr').forEach(function (tr) {
      var td = tr.querySelectorAll('td');
      if (td.length === 2) out.glance.push([td[0].textContent.trim(), td[1].textContent.trim()]);
    });
    var sec = 'Specifications';
    d.querySelectorAll('.gb-pd__specs tr').forEach(function (tr) {
      if (tr.classList.contains('gb-pd__sec')) { sec = tr.textContent.trim(); return; }
      var td = tr.querySelectorAll('td');
      if (td.length === 2) out.specs.push([sec, td[0].textContent.trim(), td[1].textContent.trim()]);
    });
    return out;
  }

  function initComparePage(root) {
    var qp = new URLSearchParams(location.search).get('p');
    var handles = qp ? qp.split(',').filter(Boolean).slice(0, MAX) : store.get().map(function (x) { return x.h; });
    var body = root.querySelector('[data-gb-cmp-body]');
    if (handles.length < 2) {
      body.innerHTML = '<div class="gb-empty"><h2>Pick at least 2 products</h2><p>Tick <strong>Compare</strong> on any two to four products of the same type, then come back here.</p><a class="gb-btn gb-btn--navy" href="/collections/appliances">Shop Appliances</a> <a class="gb-btn gb-btn--line" href="/collections/tvs">Shop TVs</a></div>';
      return;
    }
    body.innerHTML = '<p class="gb-cmp__loading">Loading comparison&hellip;</p>';
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (ps) {
      ps = ps.filter(Boolean);
      if (ps.length < 2) { body.innerHTML = '<div class="gb-empty"><h2>These products are no longer available</h2><a class="gb-btn gb-btn--navy" href="/collections/appliances">Shop Appliances</a></div>'; return; }
      var data = ps.map(function (p) { return { p: p, v: p.variants[0], d: parseDesc(p.description) }; });

      var rows = []; // [section, label, values[]]
      rows.push(['Overview', 'Brand', data.map(function (x) { return x.p.vendor; })]);
      rows.push(['Overview', 'Model', data.map(function (x) { return x.v.sku || ''; })]);
      rows.push(['Overview', 'Availability', data.map(function (x) { return x.p.available ? 'In stock' : 'Out of stock'; })]);
      TAG_ROWS.forEach(function (tr) {
        var vals = data.map(function (x) {
          return x.p.tags.filter(function (t) { return t.indexOf(tr[0]) === 0; }).map(function (t) { return tagLabel(t, tr[0]); }).join(', ');
        });
        if (vals.some(Boolean)) rows.push(['Overview', tr[1], vals]);
      });
      var seen = {};
      var addKeyed = function (sec, label, getter) {
        var k = sec + '|' + label; if (seen[k]) return; seen[k] = 1;
        var vals = data.map(getter);
        if (vals.some(Boolean)) rows.push([sec, label, vals]);
      };
      data.forEach(function (x) {
        x.d.glance.forEach(function (g) {
          if (/^(Brand|Model|Product type|Color.*)$/i.test(g[0])) return;
          addKeyed('At a Glance', g[0], function (y) { var m = y.d.glance.filter(function (z) { return z[0] === g[0]; })[0]; return m ? m[1] : ''; });
        });
      });
      data.forEach(function (x) {
        x.d.specs.forEach(function (s) {
          addKeyed(s[0], s[1], function (y) { var m = y.d.specs.filter(function (z) { return z[0] === s[0] && z[1] === s[1]; })[0]; return m ? m[2] : ''; });
        });
      });

      // group rows by section, keeping each section's first-seen position
      var secOrder = [];
      rows.forEach(function (r) { if (secOrder.indexOf(r[0]) < 0) secOrder.push(r[0]); });
      rows = secOrder.reduce(function (a, s) { return a.concat(rows.filter(function (r) { return r[0] === s; })); }, []);

      var cols = data.length;
      var head = '<tr><th class="gb-cmp__corner" scope="col"><label class="gb-cmp__diff"><input type="checkbox" data-gb-cmp-diff> Show only differences</label></th>' +
        data.map(function (x) {
          var img = x.p.featured_image ? x.p.featured_image + (x.p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
          var sale = x.v.compare_at_price && x.v.compare_at_price > x.v.price;
          return '<th scope="col" class="gb-cmp__prod">' +
            '<button type="button" class="gb-cmp__rm" data-gb-cmp-col="' + esc(x.p.handle) + '" aria-label="Remove ' + esc(x.p.title) + '">&times;</button>' +
            '<a href="/products/' + esc(x.p.handle) + '" class="gb-cmp__img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(x.p.title) + '" loading="lazy">' : '') + '</a>' +
            '<div class="gb-cmp__brand">' + esc(x.p.vendor) + '</div>' +
            '<a class="gb-cmp__title" href="/products/' + esc(x.p.handle) + '">' + esc(x.p.title) + '</a>' +
            '<div class="gb-cmp__price">' + (sale ? '<s>' + money(x.v.compare_at_price) + '</s> ' : '') + '<strong>' + money(x.v.price) + '</strong></div>' +
            (x.v.available ? '<button type="button" class="gb-btn gb-btn--buy gb-btn--block" data-gb-cmp-add="' + x.v.id + '">Add to Cart</button>' : '<button type="button" class="gb-btn gb-btn--block" disabled>Sold Out</button>') +
            '</th>';
        }).join('') + '</tr>';

      var hlRow = '<tr class="gb-cmp__row"><th scope="row">Highlights</th>' + data.map(function (x) {
        return '<td>' + (x.d.hl.length ? '<ul class="gb-cmp__hl">' + x.d.hl.slice(0, 4).map(function (h) { return '<li>' + esc(h) + '</li>'; }).join('') + '</ul>' : '') + '</td>';
      }).join('') + '</tr>';

      var bodyRows = '', lastSec = '';
      rows.forEach(function (r) {
        if (r[0] !== lastSec) { bodyRows += '<tr class="gb-cmp__sec"><th colspan="' + (cols + 1) + '" scope="colgroup">' + esc(r[0]) + '</th></tr>'; lastSec = r[0]; }
        var norm = r[2].map(function (v) { return String(v || '').toLowerCase().replace(/\s+/g, ' ').trim(); });
        var same = norm.every(function (v) { return v === norm[0]; });
        bodyRows += '<tr class="gb-cmp__row' + (same ? ' is-same' : ' is-diff') + '"><th scope="row">' + esc(r[1]) + '</th>' +
          r[2].map(function (v) { return '<td>' + (v ? esc(v) : '<span class="gb-cmp__na">&mdash;</span>') + '</td>'; }).join('') + '</tr>';
      });

      body.innerHTML = '<div class="gb-cmp__scroll" style="--gb-cmp-cols:' + cols + '"><table class="gb-cmp__table"><thead>' + head + '</thead><tbody>' + hlRow + bodyRows + '</tbody></table></div>';
      store.set(data.map(function (x) {
        return { h: x.p.handle, t: x.p.title, i: x.p.featured_image ? x.p.featured_image + (x.p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '', c: x.p.type || '' };
      }));
      renderTray();
    });

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-gb-cmp-diff]')) root.classList.toggle('gb-cmp--diff', e.target.checked);
    });
    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-gb-cmp-col]');
      if (rm) {
        var h = rm.getAttribute('data-gb-cmp-col');
        var left = store.get().filter(function (x) { return x.h !== h; });
        store.set(left);
        location.href = '/pages/compare?p=' + left.map(function (x) { return encodeURIComponent(x.h); }).join(',');
        return;
      }
      var add = e.target.closest('[data-gb-cmp-add]');
      if (add) {
        add.disabled = true; add.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +add.getAttribute('data-gb-cmp-add'), quantity: 1 }] }) })
          .then(function (r) { if (!r.ok) throw 0; location.href = '/cart'; })
          .catch(function () { add.disabled = false; add.textContent = 'Try again'; });
      }
    });
  }

  /* ---------- Package builder ---------- */
  var colCache = {};
  function loadCollection(handle) {
    if (colCache[handle]) return colCache[handle];
    var all = [];
    var page = function (n) {
      return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { all = all.concat(j.products || []); return (j.products || []).length === 250 && n < 6 ? page(n + 1) : all; });
    };
    colCache[handle] = page(1).catch(function () { return all; });
    return colCache[handle];
  }
  function cents(s) { return Math.round(parseFloat(s || 0) * 100); }
  function colorOf(p) { var t = p.tags.filter(function (x) { return x.indexOf('color_') === 0; })[0]; return t ? tagLabel(t, 'color_') : ''; }

  function initPackages(root) {
    var cfg; try { cfg = JSON.parse(document.querySelector('[data-gb-pkg-config]').textContent); } catch (e) { return; }
    var pkgs = cfg.packages.filter(function (p) { return p.slots.length; });
    if (!pkgs.length) return;
    var tabs = root.querySelector('[data-gb-pkg-tabs]'), slotsEl = root.querySelector('[data-gb-pkg-slots]');
    var sumEl = root.querySelector('[data-gb-pkg-summary]'), form = root.querySelector('[data-gb-pkg-form]');
    var state = { pkg: 0, picks: {}, match: true, open: null };
    var qsPkg = new URLSearchParams(location.search).get('package');
    pkgs.forEach(function (p, i) { if (qsPkg && p.name.toLowerCase().indexOf(qsPkg.toLowerCase()) > -1) state.pkg = i; });

    tabs.innerHTML = pkgs.map(function (p, i) {
      return '<button type="button" role="tab" class="gb-pkg__tab" data-gb-pkg-tab="' + i + '" aria-selected="' + (i === state.pkg) + '"><strong>' + esc(p.name) + '</strong><span>' + esc(p.sub || p.slots.map(function (s) { return s.label; }).join(' · ')) + '</span></button>';
    }).join('');

    function slotKey(i) { return state.pkg + ':' + i; }
    function firstPick() {
      var s = pkgs[state.pkg].slots;
      for (var i = 0; i < s.length; i++) if (state.picks[slotKey(i)]) return state.picks[slotKey(i)];
      return null;
    }

    function renderSlots() {
      var p = pkgs[state.pkg];
      slotsEl.innerHTML = p.slots.map(function (s, i) {
        var pick = state.picks[slotKey(i)];
        var inner;
        if (pick) {
          var img = pick.images[0] ? pick.images[0].src + (pick.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          var v = pick.variants[0];
          inner = '<div class="gb-pkg__pick">' + (img ? '<img src="' + esc(img) + '" alt="" width="88" height="88" loading="lazy">' : '') +
            '<div><div class="gb-pkg__brand">' + esc(pick.vendor) + '</div><a href="/products/' + esc(pick.handle) + '" target="_blank" rel="noopener" class="gb-pkg__ptitle">' + esc(pick.title) + '</a>' +
            '<div class="gb-pkg__meta">Model ' + esc(v.sku || '') + (colorOf(pick) ? ' · ' + esc(colorOf(pick)) : '') + '</div>' +
            '<div class="gb-pkg__price">' + money(cents(v.price)) + '</div></div>' +
            '<div class="gb-pkg__pickacts"><button type="button" class="gb-btn gb-btn--line" data-gb-pkg-open="' + i + '">Change</button><button type="button" class="gb-pkg__remove" data-gb-pkg-clear="' + i + '">Remove</button></div></div>';
        } else {
          inner = '<button type="button" class="gb-pkg__choose" data-gb-pkg-open="' + i + '"><span class="gb-pkg__plus" aria-hidden="true">+</span>Choose a ' + esc(s.label.toLowerCase()) + '</button>';
        }
        return '<div class="gb-pkg__slot' + (pick ? ' is-picked' : '') + '" data-slot="' + i + '">' +
          '<div class="gb-pkg__slothead"><span class="gb-pkg__step">' + (i + 1) + '</span><h3>' + esc(s.label) + '</h3>' + (s.optional ? '<span class="gb-pkg__optional">Optional</span>' : '') + '</div>' +
          inner + '<div class="gb-pkg__chooser" data-gb-pkg-chooser="' + i + '" hidden></div></div>';
      }).join('');
      if (state.open != null) openChooser(state.open);
      renderSummary();
    }

    function openChooser(i) {
      state.open = i;
      var host = slotsEl.querySelector('[data-gb-pkg-chooser="' + i + '"]');
      if (!host) return;
      slotsEl.querySelectorAll('[data-gb-pkg-chooser]').forEach(function (h) { if (h !== host) { h.hidden = true; h.innerHTML = ''; } });
      host.hidden = false;
      host.innerHTML = '<p class="gb-cmp__loading">Loading options&hellip;</p>';
      var s = pkgs[state.pkg].slots[i];
      loadCollection(s.collection).then(function (all) {
        var items = all.filter(function (p) {
          if (!p.variants.some(function (v) { return v.available; })) return false;
          if (s.tag && p.tags.indexOf(s.tag) < 0) return false;
          return true;
        });
        if (!items.length) {
          host.innerHTML = '<p class="gb-pkg__none">Nothing listed online for this right now. Our stores carry more on the floor, so add a note to your quote request and we will help you match one.</p>';
          return;
        }
        var brands = {}, colors = {};
        items.forEach(function (p) { brands[p.vendor] = (brands[p.vendor] || 0) + 1; var c = colorOf(p); if (c) colors[c] = (colors[c] || 0) + 1; });
        var fp = firstPick(), defBrand = '', defColor = '';
        if (state.match && fp && !state.picks[slotKey(i)]) {
          if (brands[fp.vendor]) defBrand = fp.vendor;
          var fc = colorOf(fp); if (fc && colors[fc]) defColor = fc;
        }
        var opt = function (o, sel) { return Object.keys(o).sort().map(function (k) { return '<option value="' + esc(k) + '"' + (k === sel ? ' selected' : '') + '>' + esc(k) + ' (' + o[k] + ')</option>'; }).join(''); };
        host.innerHTML =
          '<div class="gb-pkg__filters">' +
            '<label><span>Brand</span><select class="gb-select" data-f="brand"><option value="">All brands</option>' + opt(brands, defBrand) + '</select></label>' +
            '<label><span>Finish</span><select class="gb-select" data-f="color"><option value="">All finishes</option>' + opt(colors, defColor) + '</select></label>' +
            '<label><span>Sort</span><select class="gb-select" data-f="sort"><option value="asc">Price: low to high</option><option value="desc">Price: high to low</option></select></label>' +
            '<label class="gb-pkg__search"><span>Search</span><input type="search" class="gb-select" data-f="q" placeholder="Model or keyword"></label>' +
          '</div>' +
          ((defBrand || defColor) ? '<p class="gb-pkg__matchnote">Showing ' + esc([defBrand, defColor].filter(Boolean).join(' · ')) + ' to match your first pick. Change the filters to see everything.</p>' : '') +
          '<ul class="gb-pkg__list" data-list></ul>' +
          '<div class="gb-pkg__more"><button type="button" class="gb-btn gb-btn--line" data-more hidden>Show more</button><button type="button" class="gb-pkg__cancel" data-gb-pkg-close>Cancel</button></div>';
        var limit = 12;
        var draw = function () {
          var f = {}; host.querySelectorAll('[data-f]').forEach(function (el) { f[el.dataset.f] = el.value; });
          var q = (f.q || '').toLowerCase().trim();
          var list = items.filter(function (p) {
            if (f.brand && p.vendor !== f.brand) return false;
            if (f.color && colorOf(p) !== f.color) return false;
            if (q && (p.title + ' ' + (p.variants[0].sku || '')).toLowerCase().indexOf(q) < 0) return false;
            return true;
          }).sort(function (a, b) { var d = cents(a.variants[0].price) - cents(b.variants[0].price); return f.sort === 'desc' ? -d : d; });
          var ul = host.querySelector('[data-list]');
          ul.innerHTML = list.slice(0, limit).map(function (p) {
            var v = p.variants[0], img = p.images[0] ? p.images[0].src + (p.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
            return '<li><button type="button" class="gb-pkg__opt" data-gb-pkg-select="' + esc(p.handle) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="gb-pkg__noimg"></span>') +
              '<span class="gb-pkg__optbody"><span class="gb-pkg__brand">' + esc(p.vendor) + '</span><span class="gb-pkg__optitle">' + esc(p.title) + '</span><span class="gb-pkg__meta">Model ' + esc(v.sku || '') + (colorOf(p) ? ' · ' + esc(colorOf(p)) : '') + '</span></span>' +
              '<span class="gb-pkg__optprice">' + money(cents(v.price)) + '<span class="gb-pkg__sel">Select</span></span></button></li>';
          }).join('') || '<li class="gb-pkg__none">No matches. Try another brand or finish.</li>';
          var more = host.querySelector('[data-more]');
          more.hidden = list.length <= limit;
          more.textContent = 'Show more (' + (list.length - limit) + ')';
        };
        host.addEventListener('change', function (e) { if (e.target.matches('[data-f]')) { limit = 12; draw(); } });
        host.addEventListener('input', function (e) { if (e.target.matches('[data-f="q"]')) { limit = 12; draw(); } });
        host.querySelector('[data-more]').addEventListener('click', function () { limit += 12; draw(); });
        host.addEventListener('click', function (e) {
          var b = e.target.closest('[data-gb-pkg-select]');
          if (!b) return;
          var p = items.filter(function (x) { return x.handle === b.getAttribute('data-gb-pkg-select'); })[0];
          if (p) { state.picks[slotKey(i)] = p; state.open = null; renderSlots(); var next = slotsEl.querySelector('.gb-pkg__slot:not(.is-picked) [data-gb-pkg-open]'); if (next) next.focus(); }
        });
        draw();
        var first = host.querySelector('select'); if (first) first.focus({ preventScroll: true });
        host.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }

    function chosen() {
      var p = pkgs[state.pkg], out = [];
      p.slots.forEach(function (s, i) { var x = state.picks[slotKey(i)]; if (x) out.push({ slot: s.label, p: x, v: x.variants[0] }); });
      return out;
    }

    function renderSummary() {
      var c = chosen(), total = 0, reg = 0;
      c.forEach(function (x) { var pr = cents(x.v.price); total += pr; reg += Math.max(pr, cents(x.v.compare_at_price)); });
      var pkgName = pkgs[state.pkg].name;
      sumEl.innerHTML =
        '<h2 class="gb-pkg__sumtitle">Your ' + esc(pkgName) + '</h2>' +
        (c.length ? '<ul class="gb-pkg__sumlist">' + c.map(function (x) {
          return '<li><span><small>' + esc(x.slot) + '</small>' + esc(x.p.vendor) + ' ' + esc(x.v.sku || '') + '</span><strong>' + money(cents(x.v.price)) + '</strong></li>';
        }).join('') + '</ul>' : '<p class="gb-pkg__sumempty">Choose your appliances on the left. Your package and total show up here.</p>') +
        '<div class="gb-pkg__total"><span>Package total</span><strong>' + money(total) + '</strong></div>' +
        (reg > total ? '<p class="gb-pkg__save">Includes ' + money(reg - total) + ' in current savings vs. regular price</p>' : '') +
        '<p class="gb-pkg__fine">Before tax, delivery and installation.</p>' +
        '<button type="button" class="gb-btn gb-btn--buy gb-btn--block" data-gb-pkg-cart' + (c.length ? '' : ' disabled') + '>Add Package to Cart</button>' +
        '<button type="button" class="gb-btn gb-btn--line gb-btn--block" data-gb-pkg-quote' + (c.length ? '' : ' disabled') + '>Request a Package Quote</button>';
      var ta = form && form.querySelector('[data-gb-pkg-body]');
      if (ta) {
        ta.value = pkgName + '\n' + c.map(function (x) {
          return '- ' + x.slot + ': ' + x.p.vendor + ' ' + (x.v.sku || '') + ' (' + x.p.title + ') ' + money(cents(x.v.price)) + ' ' + location.origin + '/products/' + x.p.handle;
        }).join('\n') + '\nOnline total: ' + money(total);
      }
      var pk = form && form.querySelector('[data-gb-pkg-name]'); if (pk) pk.value = pkgName;
      var fl = form && form.querySelector('[data-gb-pkg-formlist]');
      if (fl) fl.innerHTML = c.length ? c.map(function (x) { return '<li>' + esc(x.slot) + ': ' + esc(x.p.vendor) + ' ' + esc(x.v.sku || '') + ' &ndash; ' + money(cents(x.v.price)) + '</li>'; }).join('') : '<li>No items selected yet</li>';
    }

    root.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-gb-pkg-tab]'))) {
        state.pkg = +t.getAttribute('data-gb-pkg-tab'); state.open = null;
        tabs.querySelectorAll('[data-gb-pkg-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b === t)); });
        renderSlots(); return;
      }
      if ((t = e.target.closest('[data-gb-pkg-open]'))) { openChooser(+t.getAttribute('data-gb-pkg-open')); return; }
      if ((t = e.target.closest('[data-gb-pkg-close]'))) { state.open = null; renderSlots(); return; }
      if ((t = e.target.closest('[data-gb-pkg-clear]'))) { delete state.picks[slotKey(+t.getAttribute('data-gb-pkg-clear'))]; renderSlots(); return; }
      if ((t = e.target.closest('[data-gb-pkg-cart]'))) {
        var items = chosen().map(function (x) { return { id: x.v.id, quantity: 1 }; });
        if (!items.length) return;
        t.disabled = true; t.textContent = 'Adding…';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'error'); }); location.href = '/cart'; })
          .catch(function (err) { t.disabled = false; t.textContent = 'Add Package to Cart'; alertBox(err.message); });
        return;
      }
      if ((t = e.target.closest('[data-gb-pkg-quote]'))) {
        if (form) { form.hidden = false; form.scrollIntoView({ behavior: 'smooth', block: 'start' }); var f1 = form.querySelector('input:not([type=hidden])'); if (f1) f1.focus({ preventScroll: true }); }
      }
    });
    root.addEventListener('change', function (e) { if (e.target.matches('[data-gb-pkg-match]')) { state.match = e.target.checked; } });

    function alertBox(msg) {
      var n = root.querySelector('[data-gb-pkg-alert]');
      if (n) { n.textContent = 'Some items could not be added: ' + msg; n.hidden = false; }
    }
    renderSlots();
  }

  /* ---------- Boot ---------- */
  function boot() {
    syncToggles();
    renderTray();
    var c = document.querySelector('[data-gb-compare-page]'); if (c) initComparePage(c);
    var p = document.querySelector('[data-gb-packages]'); if (p) initPackages(p);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
